import { Box, Button, Checkbox, Divider, Grid, IconButton, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ExtensionModalHeading from './ExtensionModalHeading';

import mixpanel from '../../../../utils/mixpanel';

const style = {
  position: 'absolute',
  top: '50%',
  left: '52.3%',
  transform: 'translate(-50%, -50%)',
  width: '100vw',
  bgcolor: '#f2a83f',
  pt: 1,
  borderRadius: '15px',
  zIndex: 111,
};

function ExtensionModal(props) {
  
  return (
    <Modal
      open={props.open}
      // onClose={() => {
      //   props.close(false);
      // }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box >
        <Grid
          container
          width={'90%'}
          justifyContent={'center'}
        >
         <Grid 
         sx={style}
         item xl={6} lg={7} md={9} sm={12} xs={12}>
          <Grid container
          
          style={{ background: '#FFFDEF', paddingLeft: '60px', paddingRight: '30px', marginTop: '5px' }}
          
          >
          <Grid item width={'100%'} textAlign={'end'} style={{ marginTop: '10px' }} >
            <IconButton
              onClick={() => {
                const currentTime = new Date().getTime();
                localStorage.setItem('extensionTime', parseInt(currentTime));
                var ext = localStorage.getItem('extension');
                localStorage.setItem('extension', parseInt(ext) + 1);
                props.close(false);
              }}
            >
              <CloseIcon style={{ fontSize: '30px' }}></CloseIcon>
            </IconButton>
          </Grid>
          <Grid item width={'100%'}>
            <Grid container width={'100%'}>
              <Grid item width={'50%'}>
                <Grid container direction={'column'}>
                  <Grid item>
                    <Grid container justifyContent={'start'} alignItems={'center'}>
                      <Grid item xs={4} sm={3} md={3} lg={3} xl={3}>  
                        <Grid
                          container
                          justifyContent={'center'}
                          alignItems={'center'}
                          style={{
                            background: '#f4af40',
                            width: '70px',
                            height: '70px',
                            borderRadius: '20px',
                          }}
                        >
                          <AutoAwesomeIcon
                            style={{ width: '100%', fontSize: '40px', color: '#fff' }}
                          ></AutoAwesomeIcon>
                        </Grid>
                      </Grid>
                      <Grid item xs={8} sm={9} md={9} lg={9} xl={9}>
                        <Grid container direction={'column'}>
                          <Grid item>
                            <Typography style={{ fontSize: '25px', fontWeight: '600', color: '#000' }}>
                              Influencer.in
                            </Typography>
                          </Grid>
                          <Grid item>
                            <Typography
                              style={{ fontSize: '17px', fontWeight: '600', color: '#707070' }}
                            >
                              {' '}
                              Chrome Extension
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item style={{ marginTop: '30px' }}>
                    <Typography style={{ fontSize: '18px', fontWeight: '500', color: '#707070' }}>
                      Transform your influencer discovery experience on Instagram & YouTube with
                      instant analytics and insights. Access comprehensive data while browsing
                      creator profiles—all in one click.
                    </Typography>
                  </Grid>
                  <Grid item style={{ marginTop: '40px' }}>
                    <Button
                      variant="contained"
                      onClick={() => {
                          window.open(
                            'https://chromewebstore.google.com/detail/influencerin-analyze-inst/ojmcehcdkmmdeokikaambmmifnieokbi',
                            '_blank',
                            'noopener,noreferrer',
                          )
                          mixpanel.track('Chrome-Extension-Download-Click', {
                            'from': 'Banner'
                          });
                        }
                      }
                      style={{
                        width: '90%',
                        borderRadius: '20px',
                        background: 'linear-gradient(to right, #505050, #202020)',
                        border: '2px solid #ffffff',
                        marginBottom:'20px'
                      }}
                    >
                      <Grid container width={'100%'} alignItems={'center'} style={{ padding: '15px' }}>
                        <Grid item width={'100%'} xs={11} md={11} xl={11}>
                          <Grid container width={'100%'} alignItems={'center'}>
                            <Grid item md={1}>
                              <SystemUpdateAltIcon
                                style={{ fontSize: '17px', color: '#fff', marginTop: '5px' }}
                              ></SystemUpdateAltIcon>
                            </Grid>
                            <Grid item md={10} style={{ marginLeft: '15px' }} textAlign={'start'}>
                              <Typography
                                style={{ fontSize: '16px', color: '#fff', fontWeight: '600' }}
                              >
                                Download Extension Now !
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          xs={1} md={1} xl={1}
                          width={'10%'}
                          textAlign={'end'}
                          style={{ marginTop: '10px', color: '#fff' }}
                        >
                          <ArrowForwardIcon style={{fontSize:'18px',}}></ArrowForwardIcon>
                        </Grid>
                      </Grid>
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item width={'50%'}>
                <Grid container width={'100%'} height={'100%'}>
                  <Grid item width={'1px'}>
                    <Divider
                      orientation="vertical"
                      flexItem
                      style={{ marginInline: "16px", background: '#dedede', width: '2px', height: '82%' }}
                    ></Divider>
                  </Grid>
                  <Grid item width={'99%'} style={{ paddingLeft: '30px' }}>
                    <Grid container width={'100%'} height={'100px'}>
                      <Grid item md={12}>
                        <ExtensionModalHeading
                          heading={'Instant Analytics Access'}
                          subHeading={'Get real-time metrics as you browse'}
                        ></ExtensionModalHeading>
                      </Grid>
                      <Grid item md={12} style={{ marginTop: '60px' }}>
                        <ExtensionModalHeading
                          heading={'Engagement Insights'}
                          subHeading={'Track performance metrics instantly'}
                        ></ExtensionModalHeading>
                      </Grid>
                      <Grid item md={12} style={{ marginTop: '60px' }}>
                        <ExtensionModalHeading
                          heading={'Demographics & Reach'}
                          subHeading={'Understand audience insights better'}
                        ></ExtensionModalHeading>
                      </Grid>
                      <Grid item md={12} style={{ marginTop: '13px', width: '100%' }}>
                        <Grid container justifyContent={'flex-end'} alignItems={'center'}>
                          <Grid item>
                            <Typography>Do not show again</Typography>
                          </Grid>
                          <Grid item >
                            <Checkbox defaultChecked={false} onChange={(event)=>{
                              localStorage.setItem('popUpAppearance','doNotShowpopUp')
                            }}/>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          </Grid>
         </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export default ExtensionModal;
